module.exports = __webpack_public_path__ + "img/nolan-data-protection.199d6539.svg";